import { toDisplayString as _toDisplayString, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fire.png'
import _imports_1 from '@/assets/images/spoon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-db894a90")

_pushScopeId("data-v-db894a90")
const _hoisted_1 = { class: "detail-title-view" }
const _hoisted_2 = { class: "detail-title-view-label-view-area" }
const _hoisted_3 = { class: "detail-title-view-title-area" }
const _hoisted_4 = { class: "detail-title-view-title-left-area" }
const _hoisted_5 = { class: "detail-title-view-sub-title-view-area" }
const _hoisted_6 = { class: "detail-title-view-title-view-area" }
const _hoisted_7 = { class: "detail-title-view-appliance-category-area" }
const _hoisted_8 = { class: "detail-title-view-appliance-category-label" }
const _hoisted_9 = { class: "detail-title-view-nutrition-area" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "detail-title-view-calories-icon",
  src: _imports_0
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "detail-title-view-nutrition-summay-text" }, "約", -1)
const _hoisted_12 = { class: "detail-title-view-calories-text" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "detail-title-view-nutrition-summay-text" }, "kcal", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "detail-title-view-salt-icon",
  src: _imports_1
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "detail-title-view-nutrition-summay-text" }, "約", -1)
const _hoisted_16 = { class: "detail-title-view-salt-text" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "detail-title-view-nutrition-summay-text" }, "グラム", -1)
const _hoisted_18 = { class: "detail-title-view-nutrition-note-view-area" }
const _hoisted_19 = { class: "detail-title-view-note-view-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", {
        class: "detail-title-view-label-view",
        style: {
          color: _ctx.getLabelColor(),
          backgroundColor: _ctx.getLabelBackgroundColor()
        }
      }, _toDisplayString(_ctx.label), 5), [
        [_vShow, _ctx.isShowLabel()]
      ])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", {
            innerHTML: _ctx.subTitle,
            class: "detail-title-view-sub-title-view"
          }, null, 8, ["innerHTML"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", {
            innerHTML: _ctx.title,
            class: "detail-title-view-title-view"
          }, null, 8, ["innerHTML"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.getCategoryIcon(_ctx.applianceCategoryId))
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "detail-title-view-appliance-category-icon",
            src: _ctx.getCategoryIcon(_ctx.applianceCategoryId)
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.applianceCategory), 1)
    ]),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _hoisted_10,
      _hoisted_11,
      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.getCalories()), 1),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.getSalt()), 1),
      _hoisted_17,
      _withDirectives(_createVNode("div", _hoisted_18, [
        _createVNode("div", {
          innerHTML: _ctx.getNutritionNote(),
          class: "detail-title-view-nutrition-note-view"
        }, null, 8, ["innerHTML"])
      ], 512), [
        [_vShow, _ctx.getNutritionNote()]
      ])
    ], 512), [
      [_vShow, _ctx.isShowNutrition()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_19, [
      _createVNode("div", {
        innerHTML: _ctx.note,
        class: "detail-title-view-note-view"
      }, null, 8, ["innerHTML"])
    ], 512), [
      [_vShow, _ctx.note]
    ])
  ]))
})